import { splitProps } from "solid-js"
import * as DialogPrimitive from "@kobalte/core/dialog"
import { cn } from "~/lib/utils"

const Sheet = (props) => <DialogPrimitive.Root data-slot="sheet" {...props} />

const SheetTrigger = (props) => <DialogPrimitive.Trigger data-slot="sheet-trigger" {...props} />

const SheetClose = (props) => <DialogPrimitive.CloseButton data-slot="sheet-close" {...props} />

const SheetPortal = (props) => <DialogPrimitive.Portal data-slot="sheet-portal" {...props} />

const SheetOverlay = (props) => {
  const [local, others] = splitProps(props, ["class"])
  return (
    <DialogPrimitive.Overlay
      data-slot="sheet-overlay"
      class={cn(
        "fixed inset-0 z-50 bg-black/50 data-[expanded]:animate-in data-[closed]:animate-out data-[closed]:fade-out-0 data-[expanded]:fade-in-0",
        local.class
      )}
      {...others}
    />
  )
}

const SheetContent = (rawProps) => {
  const [local, others] = splitProps(rawProps, ["class", "children", "position"])
  const pos = () => local.position ?? "right"
  return (
    <SheetPortal>
      <SheetOverlay />
      <DialogPrimitive.Content
        data-slot="sheet-content"
        class={cn(
          "fixed z-50 flex flex-col gap-4 bg-background shadow-lg transition ease-in-out data-[expanded]:animate-in data-[closed]:animate-out data-[closed]:duration-300 data-[expanded]:duration-500",
          pos() === "right" && "inset-y-0 right-0 h-full w-3/4 border-l data-[closed]:slide-out-to-right data-[expanded]:slide-in-from-right sm:max-w-sm",
          pos() === "left"  && "inset-y-0 left-0 h-full w-3/4 border-r data-[closed]:slide-out-to-left data-[expanded]:slide-in-from-left sm:max-w-sm",
          pos() === "top"   && "inset-x-0 top-0 h-auto border-b data-[closed]:slide-out-to-top data-[expanded]:slide-in-from-top",
          pos() === "bottom"&& "inset-x-0 bottom-0 h-auto border-t data-[closed]:slide-out-to-bottom data-[expanded]:slide-in-from-bottom",
          local.class
        )}
        {...others}
      >
        {local.children}
      </DialogPrimitive.Content>
    </SheetPortal>
  )
}

const SheetHeader = (props) => {
  const [local, others] = splitProps(props, ["class"])
  return <div data-slot="sheet-header" class={cn("flex flex-col gap-1.5 p-4", local.class)} {...others} />
}

const SheetFooter = (props) => {
  const [local, others] = splitProps(props, ["class"])
  return <div data-slot="sheet-footer" class={cn("mt-auto flex flex-col gap-2 p-4", local.class)} {...others} />
}

const SheetTitle = (props) => {
  const [local, others] = splitProps(props, ["class"])
  return <DialogPrimitive.Title data-slot="sheet-title" class={cn("font-semibold text-foreground", local.class)} {...others} />
}

const SheetDescription = (props) => {
  const [local, others] = splitProps(props, ["class"])
  return <DialogPrimitive.Description data-slot="sheet-description" class={cn("text-sm text-muted-foreground", local.class)} {...others} />
}

export {
  Sheet, SheetTrigger, SheetClose, SheetContent,
  SheetHeader, SheetFooter, SheetTitle, SheetDescription,
}
